<template>
  <div
    v-if="show"
    class="fixed inset-0 z-50 flex items-center justify-center bg-black/50"
    @click.self="$emit('close')"
  >
    <div class="bg-white rounded-2xl shadow-xl w-[90%] max-w-3xl p-6 relative">

      <button
        @click="$emit('close')"
        class="absolute top-4 right-4 text-gray-400 hover:text-gray-700 text-2xl"
      >
        ×
      </button>

      <h2 class="text-2xl font-bold mb-6 text-center text-gray-800">
        Acessar sistema
      </h2>

      <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
        <a
          v-for="(item, index) in sistemas"
          :key="item.nome"
          :href="resolveLink(item)"
          :target="canOpen(item) ? '_blank' : null"
          :aria-disabled="!canOpen(item)"
          class="group border rounded-2xl p-6 text-center transition-all duration-200"
          :class="[
            canOpen(item)
              ? 'hover:border-orange-500 hover:shadow-lg hover:-translate-y-0.5'
              : 'opacity-50 cursor-not-allowed',
            index === sistemas.length - 1 && sistemas.length % 2 !== 0
              ? 'md:col-span-2'
              : ''
          ]"
          @click.prevent="handleClick(item)"
        >
          <img
            :src="item.icon"
            alt=""
            class="h-12 mx-auto mb-4 transition-transform duration-200 group-hover:scale-105"
          />

          <h3 class="font-semibold text-gray-800 text-lg">
            {{ item.nome }}
          </h3>

          <p class="text-sm text-gray-500 mt-2">
            {{ item.descricao }}
          </p>

          <div
            v-if="item.platforms"
            class="flex justify-center gap-4 mt-4 text-gray-400 group-hover:text-orange-500 transition"
          >
            <font-awesome-icon
              v-if="item.platforms.includes('android')"
              :icon="['fab', 'android']"
              class="text-lg"
            />
            <font-awesome-icon
              v-if="item.platforms.includes('ios')"
              :icon="['fab', 'apple']"
              class="text-lg"
            />
          </div>

          <p
            v-if="item.platforms && !isMobile"
            class="text-xs text-gray-400 mt-3"
          >
            Disponível apenas para celular
          </p>
        </a>
      </div>

      <div class="mt-6 text-center">
        <button
          @click="$emit('close')"
          class="text-sm text-gray-500 hover:text-gray-800 underline"
        >
          Fechar
        </button>
      </div>

    </div>
  </div>
</template>

<script setup>


// eslint-disable-next-line no-undef
defineProps({ show: Boolean })

// eslint-disable-next-line no-undef
defineEmits(['close'])

import iconAdmin from '../../../public/images/overx-admin.png'
import iconOverDrive from '../../../public/images/overx-driver.png'
import iconOverStore from '../../../public/images/overx-store.png'
import iconOverxPDV from '../../../public/images/overx-pdv.png'
import iconOverxPainel from '../../../public/images/overx-painel.png'

const getUserOS = () => {
  const ua = navigator.userAgent.toLowerCase()

  if (/android/.test(ua)) return 'android'
  if (/iphone|ipad|ipod/.test(ua)) return 'ios'
  if (ua.includes('windows')) return 'windows'
  if (ua.includes('mac os') || ua.includes('macintosh')) return 'mac'
  if (ua.includes('linux')) return 'linux'

  return 'unknown'
}

const os = getUserOS()
const isMobile = os === 'android' || os === 'ios'

const resolveLink = (item) => {
  if (!item.platformLinks) return item.link || '#'
  if (!isMobile) return '#'
  return item.platformLinks[os] || '#'
}

const canOpen = (item) => {
  if (!item.platformLinks) return true
  return isMobile
}

const handleClick = (item) => {
  if (!canOpen(item)) return
  const link = resolveLink(item)
  if (link && link !== '#') {
    window.open(link, '_blank')
  }
}
const sistemas = [
  {
    nome: 'Painel',
    descricao: 'Relatórios e métricas',
    link: 'https://painel.overx.com.br/',
    icon: iconOverxPainel

  },
  {
    nome: 'Over Admin',
    descricao: 'Gerencie sua empresa',
    link: 'https://administrador.overxbrasil.com.br/',
    icon: iconAdmin
  },
  {
    nome: 'Over PDV',
    descricao: 'Gerencie pedidos',
    link: 'https://pdv.overxbrasil.com.br/',
    icon: iconOverxPDV
  },
  {
    nome: 'Over Store',
    descricao: 'Sua loja virtual',
    icon: iconOverStore,
    platforms: ['android', 'ios'],
    platformLinks: {
      android: 'https://play.google.com/store/apps/details?id=overx.store',
      ios: 'https://apps.apple.com/app/id123456789'
    }
  },
  {
    nome: 'Over Drive',
    descricao: 'Entregas e logística',
    icon: iconOverDrive,
    platforms: ['android', 'ios'],
    platformLinks: {
      android: 'https://play.google.com/store/apps/details?id=overx.drive',
      ios: 'https://apps.apple.com/app/id987654321'
    }
  }
]
</script>
